import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { router } from "@/router";
import "@/styles/main.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Clip sidecars opt into their own refetch policy; everything else stays quiet.
      refetchOnWindowFocus: false,
      retry: false
    }
  }
});

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>
);
